import { render, staticRenderFns } from "./AvatarPicker.vue?vue&type=template&id=2204305a&"
import script from "./AvatarPicker.vue?vue&type=script&lang=ts&"
export * from "./AvatarPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports